import axios from 'axios'
import baseUrl from '../config.json'
export const registerUser = userData => {
   return axios
    .post(baseUrl.apiEndPoint+'/api/auth/signup', userData)
}
export const getUser = () => {
  return axios
   .get(baseUrl.apiEndPoint+'/api/getuser')
}
const api = {
    registerUser,
    getUser
  }
  export default api